import {getDefaultPieFormatting} from '@/containers/E4ImpactMBA/charts/pie';
import {COLORS} from '@/utils/constants';

const transformData = [
    {
        name: 'Yes',
        value: 'Item 1',
        color: COLORS.e4ImpactBlue
    },
    {
        name: 'No',
        value: 'Item 2',
        color: COLORS.e4ImpactOrange
    }
];

/**
 * question: 
 * == baseline
 * question18
 * 
 * @param props 
 * @returns 
 */
export const entrepreneursRequestedFundsBeforeAccelerationProgramChartCalculation = (props: any) => {
    const data = transformData.map(({name, value, color}) => ({
        name,
        color,
        y: props.baselineSubmissions.filter((submission: any) => submission.question18 === value).length
    }))

    return getDefaultPieFormatting(
        'KPI: % of entrepreneurs who requested funds before the acceleration program',
        data
    ) as Highcharts.Options;
}